module.exports = __webpack_public_path__ + "media/img/logos/2023/horizontal/easter-0a208c7c788a0e20dc72221c34d4d556.svg";